/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import styled from 'styled-components';

export const Section = styled.section`
  background-image: url(${(props: any) => props?.bgImg});
  background-color: #cccccc;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  height: ${(props: any) => props?.height};
`;

export const Heading = styled.h1`
  text-shadow: 2px 2px #000;
  color: #ffffff !important;
`;

export const Description = styled.p`
  color: #ffffff !important;
  font-size: 24px;

  font-weight: 700 !important;
`;
